export default {"src":"/_next/static/media/users-blue.757e8c37.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};